import { useEffect, useMemo, useState } from 'react';
import useAssigneeOptions from './useAssigneeOptions';
import useFollowUpDrawer from './useFollowUpDrawer';
import useFollowUpList from './useFollowUpList';
import useQueueUrlState from './useQueueUrlState';

const useFollowUpQueue = ({
  history,
  location,
  reset,
  setReset,
}) => {
  const [refreshNonce, setRefreshNonce] = useState(0);
  const queueUrlState = useQueueUrlState({
    history,
    location,
  });
  const followUpList = useFollowUpList({
    requestParams: queueUrlState.requestParams,
    requestKey: `${queueUrlState.requestKey}:${refreshNonce}`,
  });
  const assigneeOptions = useAssigneeOptions(queueUrlState.urlFilters.assignee_id, refreshNonce);
  const drawer = useFollowUpDrawer();
  const pagination = useMemo(
    () => ({
      ...queueUrlState.urlPagination,
      total: followUpList.totalCount,
    }),
    [queueUrlState.urlPagination, followUpList.totalCount],
  );

  useEffect(() => {
    if (!reset) return;

    setRefreshNonce((nonce) => nonce + 1);
    setReset(false);
  }, [reset, setReset]);

  useEffect(() => {
    if (!drawer.selectedFollowUpId || followUpList.loading) return;

    const selectedVisible = followUpList.data.some((followup) => (
      String(followup.id) === String(drawer.selectedFollowUpId)
    ));
    if (!selectedVisible) drawer.closeDrawer();
  }, [drawer.closeDrawer, drawer.selectedFollowUpId, followUpList.data, followUpList.loading]);

  const handleFollowUpChanged = () => {
    setRefreshNonce((nonce) => nonce + 1);
  };

  return {
    data: followUpList.data,
    filters: queueUrlState.filters,
    listError: followUpList.listError,
    loading: followUpList.loading,
    options: assigneeOptions.options,
    optionsError: assigneeOptions.optionsError,
    pagination,
    selectedFollowUpId: drawer.selectedFollowUpId,
    closeDrawer: drawer.closeDrawer,
    handleClear: queueUrlState.handleClear,
    handleFollowUpChanged,
    handleTableChange: queueUrlState.handleTableChange,
    scheduleAssigneeSearch: assigneeOptions.scheduleAssigneeSearch,
    selectFollowUp: drawer.selectFollowUp,
    updateFilters: queueUrlState.updateFilters,
  };
};

export default useFollowUpQueue;
